import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useWebViewLoading } from '../../../shared/hooks/useWebViewLoading';

import './PaymentFailed.css';

/**
 * 決済失敗画面
 *
 * 決済に失敗した場合に表示する画面。
 * inquiry_idはURLパラメータ(:id)から取得する。
 * - /inquiries/:id/payment-failed         （PaymentConfirmからの遷移、GMOコールバック経由）
 * - /inquiries/:id/payment-failed?postpaidAuth=false （NP後払いの与信NG）
 * - /payment-failed                       （フォールバック、inquiry_id不明）
 *
 * 注: フォールバック時は navigate('/inquiries') での遷移を行わない。
 * PaymentComplete と同じ理由（homeId 欠落で InquiryList が無限ループする過去バグ）により、
 * フォールバック時は Flutter 側の戻るボタンでの離脱のみ許可する。
 */
const PaymentFailed: React.FC = () => {
  const navigate = useNavigate();
  const { id: inquiryId } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();

  // NP後払いの与信NG時は専用文言を出す
  const isPostpaidAuthError = searchParams.get('postpaidAuth') === 'false';

  const title = isPostpaidAuthError
    ? 'NP後払いをご利用いただけません'
    : '決済に失敗しました';
  const message = isPostpaidAuthError
    ? '今回のご注文ではNP後払いをご利用いただけません。別の決済手段をご利用ください。'
    : '決済方法選択画面へ戻り、再度お手続きをお願いします。';

  // データ取得なし（即座に表示可能）→ isLoading=false でhideLoadingを即時発火
  const contentRef = useWebViewLoading(false);

  // inquiry_idがない場合（フォールバック）
  // 遷移先が特定できないためナビゲーションボタンは置かない。
  // ユーザーは Flutter 側ヘッダーの戻るボタンから離脱する。
  if (!inquiryId) {
    return (
      <div ref={contentRef} className="failed-container">
        <main className="failed-content">
          <h2 className="failed-title">{title}</h2>
          <p>{message}</p>
        </main>
      </div>
    );
  }

  return (
    <div ref={contentRef} className="failed-container">
      <main className="failed-content">
        <h2 className="failed-title">{title}</h2>
        <p>{message}</p>
      </main>
      <footer className="failed-footer">
        <button
          className="button-primary"
          onClick={() => {
            navigate(`/inquiries/${inquiryId}/payment-method`);
          }}
        >
          決済方法選択へ戻る
        </button>
      </footer>
    </div>
  );
};

export default PaymentFailed;
